export default __webpack_public_path__ + "static/media/TLOS.660c81d3.svg";